import { useMsal } from '@azure/msal-react';
import { msalInstance, loginRequest } from '../authConfig';

// ── Standalone token helper (usable outside React components) ─────────
export async function getAuthToken(): Promise<string | null> {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (!accounts.length) return null;

    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    // acquireTokenSilent with openid/profile/email returns an ID token
    return result.idToken || null;
  } catch {
    return null;
  }
}

// ── Hook ──────────────────────────────────────────────────────────────
export function useAuth() {
  const { accounts } = useMsal();

  const user = accounts[0];
  const userId = user?.localAccountId || user?.homeAccountId;

  return {
    user,
    userId,
    isAuthenticated: !!user,
    userName: user?.name || user?.username,
    userEmail: user?.username,
    getToken: getAuthToken,
  };
}
